// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3S4q9","header":"PatientBlock_header__3PVRI","label":"PatientBlock_label__3_wz7","option":"PatientBlock_option__2MTDc"};